import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./Components/Header";
import Hero from "./Components/Hero";
import Marquee from "./Components/Marquee";
import Work from "./Components/Work";

import Technical from "./Components/Technical";
import Achievements from "./Components/Achievements";
import Footer from "./Components/Footer";

function App() {
  const [dark, setDark] = useState(true);

  useEffect(() => {
    if (dark) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [dark]);

  return (
    <>
      <div className="grain" aria-hidden="true" />
      <div className="glow" aria-hidden="true" />
      <main style={{ position: "relative", zIndex: 10, minHeight: "100vh" }}>
        <div className="container">
          <Header dark={dark} setDark={setDark} />
          <Hero />
          <Marquee />
          <Work />
          <Technical />
          <Achievements />
          <Footer />
        </div>
      </main>
    </>
  );
}

export default App;
